
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/od",
      function () {
        return require("private-next-pages/od.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/od"])
      });
    }
  